/**
 *    TBD... ANGULAR CONTEXT HOOK
 *    similar to ngContext but written as a Hook which cleans up its data instantly
 * 	  tbd global state
 */
import { useState, useEffect } from 'react';
import { ngContext } from './ng.delegate';
import { NgContext } from '../../../global';

const useNgContext = (): NgContext => {
    const [state, setState] = useState({} as NgContext);

    useEffect(() => {
        setState(ngContext());

        return (): void => {
            setState({} as NgContext);
        };
    }, []);

    return state;
};

export default useNgContext;
